import React from 'react'
import inputComponents from './inputs/inputComponents'
import { checkPermission, checkTextTranslation, getObject, setObject } from '../utils/useful'
import { LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import { nanoid } from 'nanoid';


class FormViewer extends React.Component {
    state = {
        errors: {},
        data: {},
        valid: {},
        dependencies: {},
        headers: [],
        width: window.innerWidth
    }

    componentDidMount() {
        // console.log('this.props.page', this.props.page)
        this.init()
        window.addEventListener('resize', this.setFormWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setFormWidth)
    }

    componentDidUpdate(prevProps) {

        if ((this.props.initData !== prevProps.initData) || (this.props.headers !== prevProps.headers)) {

            this.init()
        }
    }



    checkDependencies = () => {

        if (this.state.headers) {

            this.state.headers.forEach(header => {
                let hasDependency = (header.dependencies && header.dependencies.length > 0)
                if (hasDependency) {
                    let dependencies = this.state.dependencies
                    header.dependencies.forEach(dependency => {


                        let newDependency = JSON.parse(JSON.stringify(dependency))
                        newDependency.target = header.key

                        if (!dependencies[dependency.refKey]) {
                            dependencies[dependency.refKey] = []
                        }

                        dependencies[dependency.refKey].push(newDependency)
                        this.state.dependencies = dependencies

                    })
                }
            })

            if (this.state.data) {
                this.state.headers.forEach(prop => {
                    this.changeDependency(prop.key, this.state.data[prop.key], true)
                })
                this.changeDependency('*', null, true)

            }
        }
    }



    changeDependency(key, value, init, fullData) {
        let dependencies = this.state.dependencies
        // console.log("changeDependency")
        // console.log(dependencies)
        if (dependencies[key]) {

            // console.log(key)

            dependencies[key].forEach(dependency => {

                let conditions = dependency.conditions
                let variables = { data: this.state.data, fullData }
                // console.log(variables)
                let result = this.checkConditionGroup(conditions.root, variables)

                let headers = this.state.headers

                if (dependency.show != null) {
                    headers.forEach(header => {
                        if (dependency.targetKey == header.key) {
                            header.hideComponent = !result
                        }
                    });
                    this.setState({ headers })
                }

                if (dependency.changeValue != null) {
                    let data = this.state.data

                    // Support both single changeValue object and array of changeValue objects
                    const changeValues = Array.isArray(dependency.changeValue) 
                        ? dependency.changeValue 
                        : [dependency.changeValue]

                    changeValues.forEach(changeValue => {
                        // Skip update during init if fullData is required but not available
                        if (init && !fullData && changeValue.value && typeof changeValue.value === 'string' && changeValue.value.includes('@fullData')) {
                            return // Skip this changeValue update
                        }

                        let dependencyResult = true
                        if (changeValue.conditions) {
                            dependencyResult = this.checkConditionGroup(changeValue.conditions.root, variables)
                        }

                        if (dependencyResult) {
                            let newValue
                            if (changeValue.refKey) {
                                newValue = data[changeValue.refKey]
                            } else {
                                newValue = this.checkValueForVariables(changeValue.value, variables)
                                if (changeValue?.converts) {
                                    newValue = this.convertObject(newValue, changeValue.converts)
                                }
                            }

                            // support nested targetKey paths like "values.microChipNumber"
                            data = setObject(data, changeValue.targetKey, newValue)
                        }
                    })

                    this.setState({ data })
                }


                if (dependency.changeHeader != null) {
                    headers.forEach(header => {
                        if (dependency.targetKey == header.key) {
                            // console.log(this.checkValueForVariables(dependency.changeHeader.value, variables))
                            // console.log(dependency.changeHeader.value)
                            // console.log(variables)
                            let newValue = this.checkValueForVariables(dependency.changeHeader.value, variables)
                            // console.log(newValue)
                            if (dependency.changeHeader?.converts) {
                                newValue = this.convertObject(newValue, dependency.changeHeader?.converts)
                            }
                            setObject(header, dependency.changeHeader.key, newValue)
                        }
                    })
                    this.setState({ headers })
                }



                if (dependency.init != null) {
                    if (this["component-" + dependency.targetKey] && this["component-" + dependency.targetKey].init) {
                        this["component-" + dependency.targetKey].init()
                    }
                }





            });

            this.setState({ dependencies })

        }
    }


    convertObject = (object, convert) => {
        let newObject

        if (Array.isArray(object)) {

            newObject = []
            object.forEach(oneInArray => {
                let tempNewObject = this.convertOneOfObject(oneInArray, convert)
                newObject.push(tempNewObject)
            });
        } else {
            newObject = this.convertOneOfObject(object, convert)
        }
        // console.log("return")
        return newObject

    }

    convertOneOfObject(object, convert) {
        let newObject = { ...object }
        convert.forEach(oneConvert => {
            newObject[oneConvert.targetKey] = newObject[oneConvert.valueKey]
        })

        // convert.forEach(oneConvert => {
        //     delete newObject[oneConvert.valueKey]
        // })


        return newObject
    }


    checkConditionGroup = (group, variables) => {
        let result = false
        if (group.action && group.action == 'and') {
            result = true
        }
        for (const [key, value] of Object.entries(group.conditions)) {
            if (this.checkOneCondition(value, variables) != result) {
                return !result
            }
        }

        return result
    }




    checkOneCondition = (condition, variables) => {
        let action = condition.action
        if (action) {
            return this.checkConditionGroup(condition, variables)
        } else {
            // source operator target
            let source = this.checkValueForVariables(condition.source.value, variables)
            let operator = condition.operator.value
            let target = this.checkValueForVariables(condition.target.value, variables)

            return this.checkOperator(source, operator, target)

        }
    }


    checkOperator(v1, operator, v2) {

        switch (operator) {
            case '==':
                return (v1 == v2)
            case '===':
                return (v1 === v2)
            case '!=':
                return (v1 != v2)
            case '!==':
                return (v1 !== v2)
            case '<':
                return (Number(v1) < Number(v2))
            case '<=':
                return (Number(v1) <= Number(v2))
            case '>':
                return (Number(v1) > Number(v2))
            case '>=':
                return (Number(v1) >= Number(v2))
            case '&&':
                return (v1 && v2)
            case '||':
                return (v1 || v2)
            default:
                return false
        }
    }


    checkValueForVariables = (value, variables) => {
        let newValue = value

        if (typeof newValue == "string") {
            newValue = value.split(' ')

            for (let i = 0; i < newValue.length; i++) {
                const element = newValue[i]
                if (element.startsWith('@')) {
                    // console.log(this.getValueOfVariable(element, variables))
                    newValue[i] = this.getValueOfVariable(element, variables)
                }
            }
            if (newValue.length > 1) {
                newValue = newValue.join(' ')
            } else {
                newValue = newValue[0]
            }
        }

        return newValue

    }

    getValueOfVariable(element, variables) {
        // console.log(element)
        let key = element.substring(1)
        key = key.split('.')
        let variableSource = key[0]
        key.splice(0, 1)
        key = key.join('.')

        return getObject(variables[variableSource], key)
    }


    getSectionConfig = (header) => {
        if (!header || !this.props.page || !this.props.page.sections) {
            return null
        }

        const sectionKey = header.section || header.information?.section
        if (!sectionKey) {
            return null
        }

        const rawSections = this.props.page.sections
        const sections = Array.isArray(rawSections) ? rawSections : Object.values(rawSections)

        return sections.find(s =>
            s.key === sectionKey ||
            s.name === sectionKey ||
            s.id === sectionKey
        ) || null
    }


    getForm = () => {
        // console.log(this.state.data)
        if (this.validator(this.state.headers, this.state.data).valid) {
            let data = this.state.data ? { ...this.state.data } : {}
            this.state.headers.forEach(header => {

                let value = getObject(data, header.key)
                if (value && typeof value == 'object' && !Array.isArray(value) && value._id) {
                    value = value._id
                    setObject(data, header.key, value)
                }
            })
            return data
        } else {
            return null
        }
    }



    init = () => {
        // console.log(this.props.initData)

        if (this.props.headers) {
            let headers = JSON.parse(JSON.stringify(this.props.headers))
            this.setState({ headers }, () => {
                this.makeInitValue(this.props.initData)

            })
        }
    }


    validator(headers, data) {
        let valid = true
        let errors = {}
        headers.forEach(header => {

            let value = getObject(data, header.key)
            if (value && typeof value == 'object' && !Array.isArray(value) && value._id) {
                value = value._id
                // setObject(data,header.key,value)
            }
            // console.log(header.key)

            // console.log(value)


            if (header.information?.required) {


                if (header.type == 'ImageInput' || header.type == 'FileInput' || header.type == 'ImageProfileInput' || header.type == 'CaptchaInput') {

                    if (!value || value === '') {
                        value = getObject(data, ('**files.' + header.key), 1)
                    }
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                } else {
                    // let value = getObject(data, header.key)
                    if (value == null || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }

                if (header.type == 'PhoneInput') {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value.length < 14) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
                if (header.type == 'CaptchaInput') {
                    // let value = getObject(this.state.data, header.key)
                    console.log('value ===>>', value)
                    if (validateCaptcha(value) == false) {
                        valid = false
                        this.changeValue('Captcha', '')
                        errors[header.key] = '{{lang}}errors.Wrong_Capcha'
                    }
                    if (!value) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }

                if (header.type == 'SubformInput') {
                    if (!value || value.length < 1) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    } else {
                        value.forEach(subValue => {
                            // header.information.headers.forEach(subHeader => {
                            // console.log(subHeader)
                            let validator = this.validator(header.information.headers, subValue)
                            if (!validator.valid) {
                                valid = false
                                // console.log(validator)
                                errors[header.key] = '{{lang}}errors.required-field'

                                // errors[header.key] = validator.errors
                            }
                            // });
                        });
                    }
                }
            }
        })

        this.setState({ errors })
        return { valid, errors }
    }




    makeInitValue(rawData) {
        // console.log(rawData)
        // let newData = {}
        // this.setState({ data: newData, show: false }, () => {
        //     if (data) {
        //         for (const [key, value] of Object.entries(data)) {
        //             this.state.headers.forEach(header => {
        //                 if (header.key === key) {
        //                     newData[key] = value
        //                 }
        //             });
        //         }
        //     }
        let data = rawData
        if (data == null) {
            data = {}
        } else {
            try {
                data = JSON.parse(JSON.stringify(data))
            } catch (e) {
                data = { ...data }
            }
        }
        let isEditing = true
        if (Object.keys(data).length == 0) {
            isEditing = false
        }

        if (this.props.isEditing != null) {
            isEditing = this.props.isEditing
        }



        if (!isEditing) {
            this.state.headers.forEach(header => {

                if (data[header.key] == null && header.information?.default != null) {
                    data[header.key] = header.information?.default
                }
            });
        }
        // console.log(data)

        this.setState({ data: data, show: true }, () => {
            this.setFormWidth()
            this.checkDependencies()
            if (this.props.liveChange) {
                this.props.liveChange(data)
            }
        })
    }

    setFormWidth = () => {
        if (this.form) {
            this.setState({ width: this.form.getBoundingClientRect().width })
        }
    }

    changeFiles = (value, key, extra) => {
        let data = this.state.data ?? {}

        if (data['**files'] == null) {
            data['**files'] = {}
        }
        if (value) {


            this.state.headers.forEach(header => {
                if (header.key == key) {
                    // value.formType = header.type
                    // value.single = header.information?.single
                }
            });
        }

        data['**files'][key] = value
        // console.log(data)
        this.setState({ data })
    }

    changeValue = (key, value, extra) => {

        // console.log(key)
        // console.log(value)
        // console.log(extra)
        // return
        let data = { ...this.state.data }
        data = setObject(data, key, value, extra?.append)
        // console.log(data)
        this.setState({ data }, () => {
            this.changeDependency(key, value,false,extra?.fullData)
        })
        // console.log(this.props.liveChange)
        if (this.props.liveChange) {
            this.props.liveChange(data)
        }
    }
    // changeValue = (key, value, extra) => {

    //     let data
    //     if (extra?.fullData != null) {
    //         // Replace form data with full record from server (e.g. after postRecord)
    //         data = extra.fullData
    //     } else {
    //         data = { ...this.state.data }
    //         data = setObject(data, key, value, extra?.append)
    //     }
    //     this.setState({ data }, () => {
    //         this.changeDependency(key, value, false, extra?.fullData)
    //     })
    //     if (this.props.liveChange) {
    //         this.props.liveChange(data)
    //     }
    // }


    // setError = (key, value) => {
    //     let errors = this.state.errors
    //     errors[key] = value
    //     this.setState({ errors })

    // }

    // setValid = (key, value) => {
    //     let valid = this.state.valid
    //     valid[key] = value
    //     this.setState({ valid })
    // }


    setStatus = (type, key, value) => {
        let errors = this.state.errors
        let valid = this.state.valid


        delete errors[key]
        delete valid[key]

        if (type == 'error') {
            errors[key] = value
        }
        if (type == 'valid') {
            valid[key] = value
        }

        this.setState({ errors, valid })

    }



    formColBuilder(col) {
        let finalCol = 'col-12'

        if (600 < this.state.width && col) {
            finalCol = 'col-' + col
        }

        return finalCol
    }


    openLinkInfo = (header, index, data) => {
        this.props.openRefModal(data, index, header.information.linkInfo)
    }




    render() {
        if (this.state.show && this.state.headers) {
            // Group headers by section so that each section can have its own background
            const groupedHeadersMap = new Map()

            this.state.headers.forEach(header => {
                if (header.hideInList) {
                    return
                }

                const sectionKey = header.section || header.information?.section || '__no_section__'
                if (!groupedHeadersMap.has(sectionKey)) {
                    const config = this.getSectionConfig(header)
                    groupedHeadersMap.set(sectionKey, {
                        key: sectionKey,
                        config,
                        headers: []
                    })
                }

                groupedHeadersMap.get(sectionKey).headers.push(header)
            })

            const groupedHeaders = Array.from(groupedHeadersMap.values())

            return (
                <section className="w-100 form" ref={(el) => this.form = el}>
                    <div className="row ">
                        {groupedHeaders.map((group, groupIndex) => {
                            const hasSection = group.key !== '__no_section__'
                            const sectionStyle = (hasSection && group.config && group.config.color) ? {
                                backgroundColor: group.config.color,
                                borderRadius: 12,
                                padding: '12px 12px 4px 12px'
                            } : {}

                            return (
                                <div key={groupIndex} className={hasSection ? 'w-100 mb-3' : 'w-100'}>
                                    <div className="row" style={sectionStyle}>
                                        {hasSection && group.config && (group.config.title || group.config.name) && (
                                            <div className="col-12 mb-2">
                                                <p style={{ fontSize: 13, fontWeight: 600, color: '#222', opacity: 0.85 }}>
                                                    {checkTextTranslation(group.config.title || group.config.name)}
                                                </p>
                                            </div>
                                        )}

                                        {group.headers.map((header, index) => {
                                // let *** gfds **** Component = inputComponents[header.type] Fixed by parisa
                                let Component = inputComponents[header.type]
                                let data = getObject(this.state.data, header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
                                let files
                                if (this.state.data && this.state.data['**files']) {
                                    files = getObject(this.state.data['**files'], header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
                                }

                                // console.log(files)


                                // console.log(header.information?.default)

                                // if (data == null && header.information?.default != null) {
                                //     // console.log(header.information?.default)

                                //     data = header.information?.default
                                // }

                                if (!header.information?.placeholder && header.information?.label) {
                                    header.information.placeholder = header.information.label
                                }

                                if (Component && !header.hideComponent) {
                                    return (
                                        <div key={index} className={" " + this.formColBuilder(header.col) + (index !== header.length - 1 ? ' mb-3' : '')}>
                                            <div className="row">
                                                {header.information?.label && (
                                                    <div className="col-12 mb-1 text-start" onClick={() => { if (header.information.linkInfo) this.openLinkInfo(header, index, data) }}>
                                                        <label style={{ color: '#9ab' }} className={'text-uppercase text-smaller mr-1 ml-1  ' + (header.information.linkInfo ? ' hasLink ' : '') + (header.information?.required ? 'required' : '')}>{checkTextTranslation(header.information?.label)}</label>
                                                    </div>
                                                )}
                                                <div className="col-12">
                                                    <div className={"flexc " + (header.information.inputClass ?? (this.props.inputClass ? this.props.inputClass : 'default-input-view ')) + ' ' + ((this.state.valid[header.key] ? ' valid-input ' : ' ') + (this.state.errors[header.key] ? ' error-input ' : ' '))} >
                                                        {header.information?.icon && (
                                                            <img className="mrd-3" src={header.information?.icon} height="25px" alt="icon" />
                                                        )}
                                                        <Component disabled={Boolean(header.information?.disabled) || ((header.information.restricted && checkPermission(this.props.variables?.permissionRoot + '.self')) ? true : false)} ref={el => this["component-" + header.key] = el} header={header} loginError={this.props.loginError} data={data} files={files} fullValues={this.state.data} changeFiles={this.changeFiles} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} openRefModal={this.props.openRefModal} functionsHandler={this.props.functionsHandler} />
                                                    </div>
                                                </div>

                                                {header.information?.hint && (
                                                    <div className="col-12 mt-1 mld-2 text-start">
                                                        <small style={{ color: '#9ab', fontSize: 12 }}>{checkTextTranslation(header.information?.hint)}</small>
                                                    </div>
                                                )}

                                                {this.props.errors && this.props.errors[header.key] && (
                                                    <div className="col-12 mt-1 mld-2 text-start">
                                                        <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors[header.key])}</small>
                                                    </div>
                                                )}

                                                {this.state.errors && this.state.errors[header.key] && (!this.props.errors || !this.props.errors[header.key]) && (
                                                    <div className="col-12 mt-1 mld-2 text-start">
                                                        <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.state.errors[header.key])}</small>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    )
                                }
                                        })}
                                    </div>
                                </div>
                            )
                        })}
                        {this.props.errors && (typeof this.props.errors == 'string') && (
                            <div className="col-12 text-start">
                                <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors)}</small>
                            </div>
                        )}
                    </div>

                </section>
            )
        } else {
            return (<div></div>)
        }
    }
}

export default FormViewer;